// GoogleMapComponent.tsx
import React, { useEffect, useRef } from 'react';
import { generateCss } from '../../functions/sortableFunctions';

interface LatLng {
    lat: number;
    lng: number;
}

interface FormattedAddress {
    address: string;
    landmark: string;
    city: string;
    state: string;
    pincode: string;
}

const FetchLocationMap: React.FC<any> = ({ block, ...props }) => {
    const mapRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const initMap = () => {
            const initialPosition: LatLng = { lat: -34.397, lng: 150.644 };

            const map = new google.maps.Map(mapRef.current as HTMLElement, {
                center: props.contextVariables?.globalVariable?.currentLocation?.geocode ?? initialPosition,
                zoom: 20,
            });

            const initialMarker = new google.maps.Marker({
                position: props.contextVariables?.globalVariable?.currentLocation?.geocode ?? initialPosition,
                map,
                draggable: true,
            });

            const geocoder = new google.maps.Geocoder();

            google.maps.event.addListener(
                initialMarker,
                'dragend',
                (event) => {
                    const latLng = {
                        lat: event.latLng.lat(),
                        lng: event.latLng.lng(),
                    };
                    geocoder.geocode({ location: latLng }, (results, status) => {
                        if (status === 'OK') {
                            if (results[0]) {
                                const addressComponents = results[0].address_components || [];
                                const formattedAddress: FormattedAddress = {
                                    address: '',
                                    landmark: '',
                                    city: '',
                                    state: '',
                                    pincode: '',
                                };

                                addressComponents.forEach((component) => {
                                    if (component.types.includes('street_number') || component.types.includes('route')) {
                                        formattedAddress.address += (formattedAddress.address ? ' ' : '') + component.long_name;
                                    }
                                    if (component.types.includes('locality')) {
                                        formattedAddress.city = component.long_name;
                                    }
                                    if (component.types.includes('sublocality')) {
                                        formattedAddress.landmark = component.long_name;
                                    }
                                    if (component.types.includes('administrative_area_level_1')) {
                                        formattedAddress.state = component.long_name;
                                    }
                                    if (component.types.includes('postal_code')) {
                                        formattedAddress.pincode = component.long_name;
                                    }
                                });

                                props.contextVariables.setGlobalVariable((prev: any) => ({
                                    ...prev,
                                    currentLocation: {
                                        geocode: latLng,
                                        address: formattedAddress,
                                    },
                                }));
                            } else {
                                console.log('No results found');
                            }
                        } else {
                            console.log(`Geocoder failed due to: ${status}`);
                        }
                    });
                }
            );
        };

        if (window.google) {
            initMap();
        } else {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places`;
            script.onload = () => initMap();
            document.body.appendChild(script);
        }
    }, [props.contextVariables]);

    return (
        <div
            id={block?.id}
            style={{ fontFamily: block?.style?.fontFamily }}
            ref={mapRef}
            className={generateCss({
                props: { ...props, block }
            })}
            {...block.data}
        />
    );
};

export default FetchLocationMap;
